const BUSINESS_TYPES = [
	{ value: 1, text: 'Franchise', railsValue: 0 },
	{ value: 2, text: 'Independent', railsValue: 1 },
	{ value: 3, text: 'Wholesaler', railsValue: 2 },
	{ value: 6, text: 'Not a dealer', railsValue: 5 },
];

const RAILS_BUSINESS_TYPE_LABELS = {
	0: 'Franchise dealer',
	1: 'Independent dealer',
	2: 'Wholesaler',
	5: 'Not a dealer',
};

export const getBusinessTypeOptionFromRails = (value) => {
	if (value === undefined || value === null || value === '') return undefined;

	return BUSINESS_TYPES.find(
		(type) => String(type.railsValue) === String(value) || RAILS_BUSINESS_TYPE_LABELS[type.railsValue] === value,
	);
};

export default BUSINESS_TYPES;
